import { catalogEntryForErrorCode } from "./cmtsApiErrorCatalog.js";
import type { CmtsApiErrorContext } from "./cmtsApiErrorTypes.js";

export function cmtsDomainRemediation(code: string, fallback: string, context?: CmtsApiErrorContext | undefined): string {
  const catalog = catalogEntryForErrorCode(code);
  if (context?.entityType === "master-data" || context?.operation?.includes("master-data")) {
    if (code === "duplicate_business_key") return "Code already exists for this tenant and master-data type.";
    if (code === "inactive_reference_used") return "Selected reference value is inactive. Activate it or choose another active value.";
    if (code === "dependency_exists" || code === "deactivation_blocked") return "This record is used by other CMTS records and cannot be deactivated until dependencies are resolved.";
  }
  if (context?.entityType === "complaint" || context?.operation?.includes("complaint")) {
    if (code === "validation_failed") return "Correct the highlighted complaint fields and submit again.";
    if (code === "duplicate_business_key") return "A complaint with the same business key already exists for this tenant.";
    if (code === "missing_reference_value") return "One or more selected complaint classification values are no longer available.";
  }
  if (context?.operation?.includes("workflow") || context?.actionCode) {
    if (code === "invalid_workflow_transition") return "This workflow action is no longer available for the current complaint state. Refresh allowed actions.";
    if (code === "unsupported_workflow_action") return "The selected workflow action is not supported by backend configuration.";
    if (code === "sod_blocked") return "Segregation of duties blocked this action. A different authorized user must complete this step.";
  }
  if (context?.entityType === "evidence" || context?.operation?.includes("evidence")) {
    if (code === "evidence_rejected") return "Evidence was rejected by backend validation. Review the file type, size, confidentiality, or scan result.";
    if (code === "evidence_missing") return "Required evidence is missing. Upload or restore the required evidence before continuing.";
  }
  return catalog?.remediation ?? fallback;
}
